/** Mirror a native purchase button after it leaves the viewport. Safe across section reloads. */
if (!customElements.get('bp-sticky-purchase')) {
  customElements.define('bp-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      const target = document.getElementById(this.dataset.buttonId);
      const button = this.querySelector('button');
      if (!target || !button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.spacer = document.createElement('div');
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.dataset.stickyPurchaseSpacer = '';
      const footer = document.querySelector('.bpf');
      if (footer) this.spacer.style.backgroundColor = getComputedStyle(footer).backgroundColor;
      document.body.append(this.spacer);
      const update = () => {
        this.frame = null;
        const visible = target.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
        button.disabled = target.disabled;
        button.setAttribute('aria-busy', target.getAttribute('aria-busy') || 'false');
        if (this.dataset.mirrorLabel === 'true') button.textContent = target.textContent.trim();
        this.spacer.style.height = `${Math.max(0, this.clientHeight - 1)}px`;
      };
      const schedule = () => { if (this.frame == null) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      button.addEventListener('click', () => { if (!target.disabled) target.click(); }, options);
      this.resizeObserver = new ResizeObserver(schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(target);
      this.mutationObserver = new MutationObserver(schedule);
      this.mutationObserver.observe(target, { attributes: true, attributeFilter: ['disabled', 'aria-busy'], childList: this.dataset.mirrorLabel === 'true', characterData: this.dataset.mirrorLabel === 'true', subtree: this.dataset.mirrorLabel === 'true' });
      update();
    }
    cleanup() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.spacer?.remove();
      this.spacer = null;
    }
    disconnectedCallback() { this.cleanup(); }
  });
}
